import Events from "@wwdev/bootstrap/Events";

class AddToCart {
	constructor(config) {
		this.config = Object.assign({
			scope: 'form[data-add-to-cart="scope"]',
			button: '[data-add-to-cart="button"]',
			hide: '[data-add-to-cart="hide"]',
			show: '[data-add-to-cart="show"]',
			amount: '[data-add-to-cart="amount"]',
		}, config);

		this.$scope = $(this.config.scope);

		if (this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.addEventListeners();
	}

	addEventListeners() {
		this.$scope.on('click', this.config.button, this.toggle.bind(this));
		this.$scope.each((index, scope) => {
			let $scope = $(scope);
			$scope.on('submit', this.addToCart.bind(this));
		});
	}

	toggle(e) {
		e.preventDefault();
		let $button = $(e.currentTarget);
		let $scope = $button.closest(this.config.scope);

		if ($scope.data('animation') == 'secondary') {
			this.secondaryAnimation($button, $scope);
		} else {
			this.primaryAnimation($button, $scope);
		}
	}

	primaryAnimation($button, $scope) {
		$scope.find(this.config.hide).animate({
			width: 'hide',
			marginLeft: "-50px",
			paddingRight: "50px",
			opacity: "0",
		}, 200);

		let $show = $scope.find(this.config.show);
		$show.animate({
			marginLeft: "0",
			opacity: "1",
		}, 200, () => {
			$show.css('pointer-events', 'unset');
			$scope.find(this.config.amount).focus();
		});
	}

	secondaryAnimation($button, $scope) {
		let $hide = $scope.find(this.config.hide);
		$hide.animate({
			opacity: ".5",
		}, 200);
		$hide.css('pointer-events', 'none')

		let $show = $scope.find(this.config.show);
		$show.animate({
			opacity: "1"
		}, 200, () => {
			$show.css('pointer-events', 'unset');
			$scope.find(this.config.amount).focus();
		});
		$show.removeClass('d-none');
	}
 
	addToCart(e) {
		e.preventDefault();
		let $form = $(e.currentTarget);
		let data = $form.serializeObject();

		$.ajax({
			url: $form.attr('action'),
			method: 'POST',
			data: data,
			success: () => {
				let $message = $('<div class="alert alert-success m-0"></div>')
				$message.html($form.data('success-message'));
				$form.before($message);
				$form.remove();
				Events.trigger('wwdev.wishlist.indicator');
			}
		});
	}
}

export default AddToCart;